<template>
  <transition name="view-fade" mode="out-in">
    <div v-if="show" class="modal__container">
      <div class="modal">
        <span @click="toggleModal(false)" class="modal__close" />

        <component
          v-if="component"
          :is="component"
        />
      </div>
    </div>
  </transition>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex'

export default {
  name: `modal`,

  // Components
  // Data
  // Computed
  computed: {
    ...mapGetters(`modal`, [`visible`, `componentName`]),

    show () {
      return this.visible || false
    },

    component () {
      return this.componentName ? () => import(`@/components/modals/${this.componentName}`) : false
    }
  },
  // Methods
  methods: {
    ...mapActions(`modal`, [`toggleModal`])
  }
  // Watchers
  // Lifecycles
  // Filters
}
</script>
